import { ApiClient } from 'src/api/axiosClient'
import { ICartItem, IQuery } from 'src/interfaces/cart-management'

export const cartManagementApi = {
  getListCarts: async (params: IQuery) => {
    return await ApiClient.get<{
      data: {
        items: ICartItem[]
        total: number
        page: number
        limit: number
      }
    }>(`/cart-ticket-items/admin/grouped-by-user`, {
      params: {
        ...params,
      },
    })
  },

  hideCart: async (guid: string) => {
    return await ApiClient.put(`/cart-ticket-items/${guid}/hide`)
  },

  reminder: async (guid: string, body: { cartTicketId: number | null }) => {
    return await ApiClient.put(`/cart-ticket-items/${guid}/reminder`, body)
  },
}
